import {showOrderSummaryStates} from "../../../../utils/boxStates";

export const formatPrice = price => price.toFixed(2);
export const formatQty = quantity => `${quantity}×`;
export const wrapWithParens = string => `(${string})`;
export const prependText = predicate => text => `${predicate}${text}`;
export const addCurrency = (text) => `$${text}`;
export const getCartSum = (cartItems) => {
  if (!cartItems) {
    return 0;
  }

  let total = 0;
  cartItems.forEach((item) => {
    const price = item.salePrice ? item.salePrice : item.retailPrice;
    total += price * item.quantity || 0;
  });

  return total;
};

export const getTotalQty = (cartItems) => {
  if (!cartItems) {
    return 0;
  }
  return cartItems.reduce((qty, item) =>
    qty + item.quantity, 0);
}

export const showOrderSummary = (boxData) => {
  if (boxData && boxData.currentBox) {
    return showOrderSummaryStates.indexOf(boxData.currentBox.boxStatus) > -1;
  }
  return false;
}

export default {
    formatPrice,
    formatQty,
    wrapWithParens,
    prependText,
    addCurrency,
}


// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/utils/helperFuncs.js